import type { ReactNode } from 'react'
import { Modal } from '@/shared/components/Modal'
import type { ModalName } from '@/lib/modalTelemetry'

interface Props {
  /** Which confirmation this is, for telemetry - the generic shell cannot name itself. */
  track: ModalName
  title: string
  message: ReactNode
  confirmLabel?: string
  danger?: boolean
  busy?: boolean
  onConfirm: () => void
  onCancel: () => void
}

export function ConfirmModal({
  track,
  title,
  message,
  confirmLabel = 'Confirm',
  danger = true,
  busy,
  onConfirm,
  onCancel,
}: Props) {
  return (
    <Modal track={track} title={title} onClose={onCancel} maxWidth={440}>
      <p style={{ fontSize: '0.85rem', color: 'var(--text2)', marginBottom: 24, lineHeight: 1.6 }}>
        {message}
      </p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
        <button className="btn btn-ghost btn-sm" onClick={onCancel} disabled={busy}>
          Cancel
        </button>
        <button
          className={`btn btn-sm ${danger ? 'btn-danger' : 'btn-primary'}`}
          onClick={onConfirm}
          disabled={busy}
        >
          {busy ? <span className="spinner" /> : confirmLabel}
        </button>
      </div>
    </Modal>
  )
}
